import React from 'react';
// import { useIntl } from 'react-intl';
// import { Tooltip } from '@mui/material';
// import StatusChip from '../../../Components/Chip/StatusChip';
// import { addZero, culture } from '../../../Helpers/dates';
import CallStatusChip from '../../../Components/ContactListWrapper/EntryComponent/CallStatusChip';
// import EventRoundedIcon from '@mui/icons-material/EventRounded';

const LongChannelStatusChip = function LongChannelStatusChip({
  data,
  updateItem,
}) {
  // const intl = useIntl();

  // return data?.lastActivityType === 'CALL' ? (
  return (
    <CallStatusChip data={data} updateItem={updateItem} calendarOptionEnabled />
  );
  /*  ) : (
    <Tooltip
      title={
        data?.lastActivityCompletedOn &&
        `${
          intl.messages.PERFORMED_BY
        } ${data?.lastActivityCompletedBy} - ${addZero(
          new Date(data?.lastActivityCompletedOn)
        )}`
      }
      placement="left"
      arrow
    >
      <StatusChip
        alternativeLabel={
          data?.lastActivityType && data?.lastActivityCompletedOn
            ? `${new Date(data?.lastActivityCompletedOn)?.toLocaleDateString(
                culture,
                {
                  day: '2-digit',
                  month: 'short',
                  year: 'numeric',
                }
              )}`
            : null
        }
        status={
          data?.lastActivityType && data?.lastActivityCompletedOn
            ? 'lastActivity'
            : 'neverCalled'
        }
        options={{ lastActivity: EventRoundedIcon, neverCalled: null }}
        colors={{ lastActivity: '#0288d1', neverCalled: '#BCBCBC' }}
      />
    </Tooltip>
  ); */
};
export default LongChannelStatusChip;
